import { cva } from 'class-variance-authority'

export const CardStyles = cva([], { variants: {} })
